import { useContext } from "react";
import { WplywContext } from "../../../../../../context/wplywContext";

const InnerStage2Checker = (selectedPerson) => {
    const { wplyw } = useContext(WplywContext);
    
    // Check if wplyw data and selectedPerson exist
    if (!wplyw?.wplyw_data?.data?.msr_wplywy || !selectedPerson) return false;

    const data = wplyw.wplyw_data.data.msr_wplywy;
    
    // Check if msr_persons exists and is an array, and find the person by id
    const person = Array.isArray(data?.msr_persons) 
        ? data.msr_persons.find((p) => p?.msr_persons_id === selectedPerson?.msr_persons_id) 
        : null;

    // If person is not found, return false
    if (!person) return false;

    // Ensure limit is a valid number
    const limit = parseFloat(selectedPerson?.msr_persons_amount) || 0;

    // Check if person.msr_reckonings is an array, if not, default to an empty array
    const reckonings = Array.isArray(person?.msr_reckonings) ? person.msr_reckonings : [];

    // Calculate the sum of msr_reckonings_part_amount, handle NaN gracefully
    const total = reckonings.reduce(
        (sum, reckoning) => sum + (parseFloat(reckoning?.msr_reckonings_part_amount) || 0), 
        0
    );
    return (total).toFixed(2) == (limit).toFixed(2) && data.msr_wplywy_date_forward && data.msr_wplywy_date_forward != 'null'
};

export default InnerStage2Checker;
